import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from './auto-image'

const Outer = styled.div`
  @media (max-width: 40rem){
    padding: 1% 0;
  }
  img, video {
    width: 100%;
    height: auto;
    mix-blend-mode: multiply;
  }
`

type BannerImageProps = {
  src: string
}
export const BannerImage: FunctionComponent<BannerImageProps> = ({src}) => {
  return <Outer>
    <AutoImage src={src} />
  </Outer>
}
export const BannerVideo: FunctionComponent<BannerImageProps> = ({src}) => {
  return <Outer>
    <video src={src} autoPlay loop muted playsInline/>
  </Outer>
}